var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1V11C2 11.5625 1.53125 12 1 12C0.4375 12 0 11.5625 0 11V1C0 0.46875 0.4375 0 1 0C1.53125 0 2 0.46875 2 1ZM13.6875 6.71875L9.6875 10.7188C9.3125 11.125 8.65625 11.125 8.28125 10.7188C7.875 10.3438 7.875 9.6875 8.28125 9.3125L10.5625 7H5C4.4375 7 4 6.5625 4 6C4 5.46875 4.4375 5 5 5H10.5625L8.28125 2.71875C7.875 2.34375 7.875 1.6875 8.28125 1.3125C8.65625 0.90625 9.3125 0.90625 9.6875 1.3125L13.6875 5.3125C14.0938 5.6875 14.0938 6.34375 13.6875 6.71875Z",
    fill: "#3C3C43",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b2fd0b68.svg";
export { ForwardRef as ReactComponent };